import { gql } from "@apollo/client";

export const CREATE_LEAD_TYPOLOGY = gql`
  mutation AddLeadTypology($data: LeadTypologyDataInput) {
    addLeadTypology(data: $data) {
      id
      label
    }
  }
`;

export const UPDATE_LEAD_TYPOLOGY = gql`
  mutation UpdateLeadTypology(
    $data: LeadTypologyDataInput
    $where: LeadTypologyWhereInput
  ) {
    updateLeadTypology(data: $data, where: $where) {
      id
      label
    }
  }
`;

export const DELETE_LEAD_TYPOLOGY = gql`
  mutation DeleteLeadTypology($where: LeadTypologyWhereInput) {
    deleteLeadTypology(where: $where) {
      id
    }
  }
`;

const leadTypologies = {
  CREATE_LEAD_TYPOLOGY,
  UPDATE_LEAD_TYPOLOGY,
  DELETE_LEAD_TYPOLOGY,
};

export default leadTypologies;
